import { useContext, memo } from 'react';
import { useIntl } from 'react-intl';
import { GlobalFooterContext } from '../../context/GlobalFooterContext.js';
import { titleMessages } from '../../messages.js';
import { messages } from '../../shared/messages/navigation.js';
import { homeUrl, learningRewardsUrl, walletUrl, cardUrl, coinbaseOneUrl } from '../../shared/utils/links.js';
import CDSFooterLink from '../CDSFooterLink.js';
import FooterColumn from './FooterColumn.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function IndividualsColumn() {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalFooterContext),
    isUserFromCountry = _useContext.isUserFromCountry;
  const isUKUser = isUserFromCountry('GB');
  return /*#__PURE__*/jsxs(FooterColumn, {
    heading: formatMessage(messages.individuals),
    children: [/*#__PURE__*/jsx(CDSFooterLink, {
      href: homeUrl,
      children: formatMessage(titleMessages.buyAndSell)
    }), !isUKUser && /*#__PURE__*/jsx(CDSFooterLink, {
      href: learningRewardsUrl,
      children: formatMessage(titleMessages.earnFreeCrypto)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.wallet),
      href: walletUrl,
      children: formatMessage(messages.wallet)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.card),
      href: cardUrl,
      children: formatMessage(messages.card)
    }), /*#__PURE__*/jsx(CDSFooterLink, {
      accessibilityLabel: formatMessage(titleMessages.coinbaseOne),
      href: coinbaseOneUrl,
      children: formatMessage(messages.coinbaseOne)
    })]
  });
}
const IndividualsColumn$1 = /*#__PURE__*/memo(IndividualsColumn);
export { IndividualsColumn$1 as default };
//# sourceMappingURL=IndividualsColumn.js.map
